import { render, staticRenderFns } from "./NovaPoshtaAddressPopup.vue?vue&type=template&id=1f29d53e&scoped=true"
import script from "./NovaPoshtaAddressPopup.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaAddressPopup.vue?vue&type=script&lang=js"
import style0 from "./NovaPoshtaAddressPopup.vue?vue&type=style&index=0&id=1f29d53e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f29d53e",
  null
  
)

export default component.exports